import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// helpers
import fp from 'lodash/fp';

// mui
import { DialogContent, DialogActions } from '@mui/material';

// components
import CBButton from '../../components/Buttons/CbButton';

import { useAPIErrorHandler } from '../../components/hooks/useAPIErrorHandler';
import useNotifications from '../../_lib/notifications/useNotifications';

// actions
import { rescindBinder } from '../QuotesService';
import {
  rescindExcessBinder,
  rescindExcessPolicyBinder,
} from '../../api/policies.api';
import { ProductTypes } from '../../types';
import { useGetBinderNumber } from './helpers/useGetBinderNumber';

export const RescindBinder = ({ data, close }: any) => {
  const notifications = useNotifications();
  const handleAPIError = useAPIErrorHandler();

  const [loading, setLoading] = useState(false);

  const { handleSubmit } = useForm();
  const binderNumber = useGetBinderNumber(data);

  const onSubmit = () => {
    setLoading(true);

    let rescindAPI;
    if (data.isPrimePlus) {
      // @ts-expect-error TS(2345): Argument of type '[any]' is not assignable to para... Remove this comment to see the full error message
      rescindAPI = fp.partial(rescindExcessBinder)([data.id]);
    } else if (
      data.product === ProductTypes.prime_tech_plus ||
      data.product === ProductTypes.p_one_plus ||
      data.product === ProductTypes.prime_one_tech_plus
    ) {
      rescindAPI = fp.partial(rescindExcessPolicyBinder)([
        data.product,
        data.id,
      ]);
    } else {
      // @ts-expect-error TS(2322): Type '{ quoteId: any; }' is not assignable to type... Remove this comment to see the full error message
      rescindAPI = fp.partial(rescindBinder)([{ quoteId: data.quoteId }]);
    }

    return rescindAPI()
      .then(() => {
        close();

        notifications.success('Binder Rescinded Successfully!');

        if (typeof data.makeRefreshCall == 'function') {
          data.makeRefreshCall();
        }
      })
      .catch(handleAPIError('Cannot Rescind Binder. Please try again later.'))
      .finally(() => setLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DialogContent
        className="modal-title"
        style={{ padding: '3rem 5rem', fontWeight: 600 }}
      >
        Are you sure you want to rescind&nbsp;&nbsp;
        {/* @ts-expect-error: fixme */}
        <span className="blue-text">Binder #{binderNumber}</span>?
      </DialogContent>
      <DialogActions>
        <CBButton action={close} styleName="cancel" buttonText="Cancel" />
        <CBButton
          type="submit"
          loading={loading}
          disabled={loading}
          styleName="ctaButton"
          buttonText="Rescind Binder"
        />
      </DialogActions>
    </form>
  );
};

export const RescindBinderConfig = {
  RescindBinder: {
    component: RescindBinder,
    config: {
      fullWidth: true,
      maxWidth: 'sm',
    },
  },
};
